import _regenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "core-js/modules/es6.string.iterator";
import _toConsumableArray from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/createClass.js";
import Vue from 'vue';
import { get as getDictDetail } from '@/api/system/dictDetail';
var Dict = /*#__PURE__*/function () {
  function Dict(dict) {
    _classCallCheck(this, Dict);
    this.dict = dict;
  }
  return _createClass(Dict, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(names, completeCallback) {
        var _this = this;
        var ps;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(names === undefined || name === null)) {
                _context.n = 1;
                break;
              }
              throw new Error('need Dict names');
            case 1:
              ps = [];
              names.forEach(function (n) {
                Vue.set(_this.dict.dict, n, {});
                Vue.set(_this.dict.label, n, {});
                Vue.set(_this.dict, n, []);
                ps.push(getDictDetail(n).then(function (data) {
                  var _this$dict$n;
                  (_this$dict$n = _this.dict[n]).splice.apply(_this$dict$n, [0, 0].concat(_toConsumableArray(data.content)));
                  data.content.forEach(function (d) {
                    Vue.set(_this.dict.dict[n], d.value, d);
                    Vue.set(_this.dict.label[n], d.value, d.label);
                  });
                }));
              });
              _context.n = 2;
              return Promise.all(ps);
            case 2:
              completeCallback();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }]);
}();
export { Dict as default };